import '../style/syncfusion27.css';
import { license } from '../license';

license();

export type { ClickEventArgs } from '@syncfusion/ej2-navigations';
export { DocumentEditorContainerComponent, Toolbar as DocumentToolbar } from '@syncfusion/ej2-react-documenteditor';
export type { CustomToolbarItemModel, ToolbarItem as DocumentToolbarItem } from '@syncfusion/ej2-react-documenteditor';
